import {RGBDualPage} from "../features/rgbdual/RGBDualPageNext"

export default RGBDualPage.Page
